import React, { useEffect } from 'react';
import { languages, changeLanguage, getCurrentLanguage } from 'utils/translation';

import {
  useScreenClass,
} from 'components/Grid';

import {
  Container,
  Item,
  DropdownContent,
  SelectedItem,
  DropdownIcon,
  LanguageLabel,
} from './styles';

const KUSTOMER_FORM_ID = process.env.REACT_APP_KUSTOMER_FORM_ID;

const LanguageSelect = () => {
  const currentLanguage = getCurrentLanguage();
  const filteredLanguages = languages.filter(lang => lang !== currentLanguage);
  const screenClass = useScreenClass();

  useEffect(() => {
    window['Kustomer'].start({ lang: currentLanguage, form: KUSTOMER_FORM_ID });
    return () => window['Kustomer'].stop();
  }, [currentLanguage]);

  const handleChangeLanguage = (newLanguage) => {
    changeLanguage(newLanguage);
    window.location.reload();
  };

  return (
    <Container>
      <div>
        <SelectedItem screenClass={screenClass}>
          <LanguageLabel>{currentLanguage.toUpperCase()}</LanguageLabel>
          <DropdownIcon id="dropdownIcon" src="/assets/icons/hero/select-icon.svg" alt="" />
        </SelectedItem>
      </div>
      <DropdownContent>
        {filteredLanguages.map((lang) => (
          <Item
            key={lang}
            screenClass={screenClass}
            onClick={() => handleChangeLanguage(lang)}
          >
            <LanguageLabel>{lang.toUpperCase()}</LanguageLabel>
          </Item>
        ))}
      </DropdownContent>
    </Container>
  );
};

export default LanguageSelect;
